function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.43,
    height: 12.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7642857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 6.175
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.35,
    width: 25.43,
    height: 16.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 20.785
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29.22,
    width: 25.43,
    height: 19.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2883333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 39.085
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 48.94,
    width: 25.43,
    height: 28.27,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.086
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 63.074999999999996
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 77.22,
    width: 25.43,
    height: 28.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.086
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 91.4
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105.58,
    width: 25.43,
    height: 28.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 119.87
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 134.17,
    width: 25.43,
    height: 28.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.543
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 148.47
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.76,
    width: 25.43,
    height: 29.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 177.35999999999999
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.97,
    width: 25.43,
    height: 32.37,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.086
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 208.155
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 224.34,
    width: 25.43,
    height: 33.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 240.955
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 257.57,
    width: 25.43,
    height: 34.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8255555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 275.01
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 292.45,
    width: 25.43,
    height: 36.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.632857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 310.79499999999996
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 329.14,
    width: 25.43,
    height: 38.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.543
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 348.51
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 367.88,
    width: 25.43,
    height: 39.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8255555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 387.40999999999997
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 406.94,
    width: 25.43,
    height: 42.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 428.075
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 449.21,
    width: 25.43,
    height: 46.73,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 472.575
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 495.95,
    width: 25.43,
    height: 49.73,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 520.8149999999999
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 545.67,
    width: 25.43,
    height: 50.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.086
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 570.6949999999999
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 595.72,
    width: 25.43,
    height: 51.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 621.585
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 647.46,
    width: 25.43,
    height: 52.54,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 673.73
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 0,
    width: 35.21,
    height: 40.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.035,
    y: 20.065
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.64,
    y: 0,
    width: 35.86,
    height: 40.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 78.57,
    y: 20.065
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 0,
    width: 37.24,
    height: 40.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3854545454545457
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.12,
    y: 20.065
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.74,
    y: 0,
    width: 37.34,
    height: 40.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3342857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.41000000000003,
    y: 20.065
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.08,
    y: 0,
    width: 37.47,
    height: 40.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.815,
    y: 20.065
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.55,
    y: 0,
    width: 39.09,
    height: 40.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5842857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.09500000000003,
    y: 20.065
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.64,
    y: 0,
    width: 39.91,
    height: 40.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.981999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.59499999999997,
    y: 20.065
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.55,
    y: 0,
    width: 40.94,
    height: 40.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.01625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.02,
    y: 20.065
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.49,
    y: 0,
    width: 42.82,
    height: 40.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.013
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.90000000000003,
    y: 20.065
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.31,
    y: 0,
    width: 43.04,
    height: 40.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6883333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.83,
    y: 20.065
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.35,
    y: 0,
    width: 43.75,
    height: 40.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.01625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.225,
    y: 20.065
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458.1,
    y: 0,
    width: 44.78,
    height: 40.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.013
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.49,
    y: 20.065
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.88,
    y: 0,
    width: 47.57,
    height: 40.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6883333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.665,
    y: 20.065
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.45,
    y: 0,
    width: 47.82,
    height: 40.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6883333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.36,
    y: 20.065
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.26,
    y: 0,
    width: 49.99,
    height: 40.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.255,
    y: 20.065
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648.26,
    y: 0,
    width: 51.74,
    height: 40.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.13,
    y: 20.065
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 40.13,
    width: 47.55,
    height: 44.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 62.375
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 84.62,
    width: 47.55,
    height: 45.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.512857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 107.415
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 130.21,
    width: 47.55,
    height: 47.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.283333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 154.13
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 178.05,
    width: 47.55,
    height: 48.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 202.48000000000002
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 226.91,
    width: 47.55,
    height: 49.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 251.425
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 275.94,
    width: 47.55,
    height: 50.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 301.185
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 326.43,
    width: 47.55,
    height: 51.19,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 352.025
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 377.62,
    width: 47.55,
    height: 51.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 403.53000000000003
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 429.43,
    width: 47.55,
    height: 52.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.94375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 455.595
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 481.76,
    width: 47.55,
    height: 52.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.94375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 507.98
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 534.2,
    width: 47.55,
    height: 53.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.283333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 561.075
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 587.95,
    width: 47.55,
    height: 54.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 615.065
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 642.18,
    width: 47.55,
    height: 57.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.205,
    y: 671.0899999999999
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 40.13,
    width: 48.49,
    height: 60.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.06125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.22500000000001,
    y: 70.21000000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.47,
    y: 40.13,
    width: 49.82,
    height: 60.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.38,
    y: 70.21000000000001
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 40.13,
    width: 51.93,
    height: 60.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.26500000000001,
    y: 70.21000000000001
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.23,
    y: 40.13,
    width: 55.51,
    height: 60.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.98499999999999,
    y: 70.21000000000001
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.74,
    y: 40.13,
    width: 57.89,
    height: 60.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.685,
    y: 70.21000000000001
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.63,
    y: 40.13,
    width: 57.92,
    height: 60.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.274285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.59,
    y: 70.21000000000001
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.55,
    y: 40.13,
    width: 58.98,
    height: 60.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.04,
    y: 70.21000000000001
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.53,
    y: 40.13,
    width: 59.94,
    height: 60.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.562857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.5,
    y: 70.21000000000001
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.47,
    y: 40.13,
    width: 61.29,
    height: 60.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.684444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 544.115,
    y: 70.21000000000001
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.75,
    y: 40.13,
    width: 61.86,
    height: 60.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.026666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.68,
    y: 70.21000000000001
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.62,
    y: 40.13,
    width: 63.38,
    height: 60.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.3100000000001,
    y: 70.21000000000001
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 100.28,
    width: 62.87,
    height: 62.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 131.5
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 162.73,
    width: 62.87,
    height: 62.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.952857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 194.065
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 225.4,
    width: 62.87,
    height: 64.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.478333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 257.71500000000003
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 290.03,
    width: 62.87,
    height: 65.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.85875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 322.575
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 355.11,
    width: 62.87,
    height: 66.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.981428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 388.45500000000004
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 421.8,
    width: 62.87,
    height: 68.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.478333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 456.01
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 490.22,
    width: 62.87,
    height: 68.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.985555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 524.525
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 558.84,
    width: 62.87,
    height: 69.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 593.82
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.98,
    y: 628.8,
    width: 62.87,
    height: 71.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.478333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.415,
    y: 664.4
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.86,
    y: 100.28,
    width: 62.42,
    height: 73.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.403333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.07000000000002,
    y: 136.815
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.28,
    y: 100.28,
    width: 64.91,
    height: 73.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.818333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.735,
    y: 136.815
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.18,
    y: 100.28,
    width: 65.65,
    height: 73.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.20625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.005,
    y: 136.815
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.83,
    y: 100.28,
    width: 68.25,
    height: 73.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.955,
    y: 136.815
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.08,
    y: 100.28,
    width: 70.67,
    height: 73.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.134
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.41499999999996,
    y: 136.815
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.75,
    y: 100.28,
    width: 76.71,
    height: 73.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.105,
    y: 136.815
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.46,
    y: 100.28,
    width: 77.32,
    height: 73.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.613999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.12,
    y: 136.815
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.78,
    y: 100.28,
    width: 78.22,
    height: 73.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.438571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.89,
    y: 136.815
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.86,
    y: 173.36,
    width: 84.2,
    height: 67.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.554444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.96,
    y: 207.35500000000002
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.86,
    y: 241.35,
    width: 84.2,
    height: 69.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.965999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.96,
    y: 276.18
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.86,
    y: 311,
    width: 84.2,
    height: 70.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.82125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.96,
    y: 346.28499999999997
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.86,
    y: 381.57,
    width: 84.2,
    height: 71.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.254
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.96,
    y: 417.205
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.86,
    y: 452.84,
    width: 84.2,
    height: 73.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.185555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.96,
    y: 489.67499999999995
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.86,
    y: 526.51,
    width: 84.2,
    height: 86.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.96,
    y: 569.84
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.86,
    y: 613.17,
    width: 84.2,
    height: 86.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.028571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.96,
    y: 656.5849999999999
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 173.36,
    width: 89.58,
    height: 83.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.8825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.84000000000003,
    y: 215.125
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.63,
    y: 173.36,
    width: 92.34,
    height: 83.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.44125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.8,
    y: 215.125
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.97,
    y: 173.36,
    width: 95.88,
    height: 83.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.44125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.91,
    y: 215.125
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.85,
    y: 173.36,
    width: 95.95,
    height: 83.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.825,
    y: 215.125
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.79,
    y: 173.36,
    width: 106.21,
    height: 83.53,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.921666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.895,
    y: 215.125
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 256.89,
    width: 90.04,
    height: 102.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.862857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.07,
    y: 308.34999999999997
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 359.81,
    width: 90.04,
    height: 103.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.07,
    y: 411.6
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 463.39,
    width: 90.04,
    height: 108.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.185454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.07,
    y: 517.71
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 572.03,
    width: 90.04,
    height: 127.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.006666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.07,
    y: 636.015
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.09,
    y: 256.89,
    width: 112.9,
    height: 107.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.709999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.53999999999996,
    y: 310.44
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 256.89,
    width: 132.2,
    height: 107.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.3875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.1,
    y: 310.44
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.2,
    y: 256.89,
    width: 144.8,
    height: 107.1,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.849999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.6,
    y: 310.44
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.09,
    y: 363.99,
    width: 146.62,
    height: 148.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.945714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.4,
    y: 438.36
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.09,
    y: 512.73,
    width: 146.62,
    height: 187.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.3275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.4,
    y: 606.365
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.72,
    y: 363.99,
    width: 243.28,
    height: 159.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.9875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.36,
    y: 443.96500000000003
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.72,
    y: 523.93,
    width: 243.28,
    height: 176.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.006363636363634
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.36,
    y: 611.9649999999999
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.30070a5f2687a7ed0570adf5f190928c.svg";
export { ForwardRef as ReactComponent };